import { EFFECT_DURATION_MS, GOLD_BONUS_POINTS } from '../../game/power-ups';
import type { PowerUpKind } from '../../shared/power-ups';

const seconds = (ms: number) => `${Math.round(ms / 1000)} seconds`;

/** Copy for each chaos power-up; the glyph and tile look belong to the theme (`themes/contract.ts`). */
export const POWER_UP_INFO: Record<PowerUpKind, { title: string; description: string }> = {
  gold: { title: 'Gold', description: `The word that takes it earns +${GOLD_BONUS_POINTS}.` },
  double: {
    title: 'Double',
    description: `Your words score double for ${seconds(EFFECT_DURATION_MS.double)}.`,
  },
  reveal: { title: 'Reveal', description: 'Lights up a word you haven’t found.' },
  shield: { title: 'Shield', description: 'Blocks the next power-up aimed at you.' },
  freeze: {
    title: 'Freeze',
    description: `Everyone else is locked out for ${seconds(EFFECT_DURATION_MS.freeze)}.`,
  },
  tax: {
    title: 'Tax',
    description: `Everyone else scores half for ${seconds(EFFECT_DURATION_MS.tax)}.`,
  },
  spin: {
    title: 'Spin',
    description: `Everyone else’s board flips for ${seconds(EFFECT_DURATION_MS.spin)}.`,
  },
  fog: {
    title: 'Fog',
    description: `Everyone else sees only the letters near their finger for ${seconds(EFFECT_DURATION_MS.fog)}.`,
  },
};
